import MuiAccordion from '@mui/material/Accordion';
import { Theme } from '@mui/material/styles';
import withStyles from '@mui/styles/withStyles';

const Accordion = withStyles((theme: Theme) => {
  return {
    root: {
      background: 'none',
      '&:before': {
        background: theme.palette.common.white,
      },
      '&:last-child': {
        borderBottom: `1px solid ${theme.palette.common.white}`,
      },
      '&$expanded': {
        margin: 0,
        '&:before': {
          opacity: 1,
        },
      },
    },
    expanded: {},
  };
})(MuiAccordion);

export default Accordion;
